import { Injectable } from '@angular/core'

import { ApiService } from './api.service'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class EligibilityRuleSetService {

  constructor(private api: ApiService) { }

  public find(ruleSetId: string): Observable<any> {
    return this.api.get('eligibility_rule_sets/' + ruleSetId)
  }
}
